import logger from "@utils/logger";

const KEY_PREFIX = "kz:gamePrefix:";

function buildKey(accountId: string | undefined): string | null {
  if (!accountId) return null;
  return `${KEY_PREFIX}${accountId}`;
}

export function readPersistedPrefix(accountId: string | undefined): string | undefined {
  const key = buildKey(accountId);
  if (!key) return undefined;
  try {
    const raw = window.localStorage.getItem(key);
    if (typeof raw !== "string" || raw.length === 0) return undefined;
    return raw;
  } catch {
    return undefined;
  }
}

export function writePersistedPrefix(accountId: string | undefined, prefix: string | undefined): void {
  const key = buildKey(accountId);
  if (!key) return;
  try {
    if (typeof prefix === "string" && prefix.length > 0) {
      window.localStorage.setItem(key, prefix);
    } else {
      window.localStorage.removeItem(key);
    }
  } catch (error) {
    logger._console.warn("[analytics] Failed to persist gamePrefix", error);
  }
}
